export default __webpack_public_path__ + "static/media/mum.826066ac.png";